<template>
  <div v-if="accountInfo.fil === 'P'">
    <h3>Passenger Name Check</h3>
    <div>
      <h5>
        <b-list-group class="mt-2">
          <b-list-group-item v-for="(item, key) in bookingNames" :key="key">
            {{ item.title }} {{ item.firstname }} {{ item.surname }} -
            <span v-if="item.nationality">{{ item.nationality }}</span>
            <span v-if="!item.nationality">
              No nationality information held
            </span>
          </b-list-group-item>
        </b-list-group>
      </h5>
      <b-list-group class="mt-3">
        <b-list-group-item variant="light">
          <b-row align-v="center">
            <b-col cols="2" class="d-flex justify-content-center">
              <b-icon
                icon="exclamation-triangle-fill"
                aria-hidden="true"
                variant="secondary"
                font-scale="2"
              />
            </b-col>
            <b-col cols="9">
              <span>
                Your first and last name must exactly match your passport.
                Middle names are not relevant at this stage.
                Please highlight any name discrepancies prior to making payment as they can be very costly to amend later.
              </span>
            </b-col>
          </b-row>
        </b-list-group-item>
      </b-list-group>
    </div>
    <b-row class="mt-4 confirmation-btns">
      <b-col class="d-flex justify-content-center">
        <b-button
          variant="danger"
          class="text-left cancel-btn"
          @click="closeModal"
        >
          Passenger names not correct. Close
        </b-button>
      </b-col>
      <b-col class="d-flex justify-content-center">
        <b-button variant="success" class="text-left" @click="nextModal">
          Passenger names are correct. Proceed
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  props: ["accountInfo", "bookingNames", "officeOpen"],
  data() {
    return {
      activeAlerts: [],
      payModalType: "card",
    };
  },
  computed: {
    ...mapGetters("booking", [
      "getBooking",
      "getFil",
      "getCountry",
      "getDescLinks",
    ]),
  },
  async mounted() {
    if (this.$route.params.source) {
      this.source = this.$route.params.source.toUpperCase();
    }
    this.fil = this.getFil;
    this.country = await this.getCountry;
    if (this.country === "IE") {
      this.referer = "ie";
    }
    this.activeAlerts = this.getDescLinks;
  },
  methods: {
    closeModal() {
      this.$emit("exitModal");
    },
    showModal(payModalType) {
      this.payModalType = payModalType;
    },
    nextModal() {
      this.$emit("nextModal", 2);
    },
    getBookingContactNumber(bookingObj) {
      if (bookingObj) {
        return bookingObj.user_information.bkgcontacts[0].line0.telno;
      }
    },
  },
};
</script>
<style lang="scss">
.confirmation-btns {
  flex-direction: column;
}
.cancel-btn {
  margin-bottom: 1rem;
}
@media only screen and (min-width: 992px) {
  .confirmation-btns {
    justify-content: center;
    flex-direction: row;
  }
  .cancel-btn {
    margin-bottom: 0;
  }
}
</style>
